import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cartSidebarOpen: false,
};

const uiSlice = createSlice({
  name: 'uiState',
  initialState: initialState,
  reducers: {
    openCartSidebar: (state) => {
      state.cartSidebarOpen = true;
    },
    closeCartSidebar: (state) => {
      state.cartSidebarOpen = false;
    },
    toggleCartSidebar: (state) => {
      state.cartSidebarOpen = !state.cartSidebarOpen;
    },
  },
});

export const { openCartSidebar, closeCartSidebar, toggleCartSidebar } = uiSlice.actions;
export const selectCartSidebarOpen = (state) => state?.uiState?.cartSidebarOpen;
export default uiSlice.reducer;
